import React from 'react';
import { withRouter, connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';

@withRouter
class ApiPage extends React.Component {
    componentWillMount() {
        this.props.router.push('/documents/docs');
    }

    render() {
        return <div></div>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        prop: state.prop
    }
};

export default connect(mapStateToProps)(ApiPage);
